<template>
  <global-dialog-card v-model="model" :title="`${$t('qr_code')} #${employee?.id}`">
    <template #title-actions>
      <print-button color="white" @click="printQr(employee)" :disabled="loading"></print-button>
    </template>

    <v-row justify="center" class="pt-5">
      <v-col cols="12" class="pa-0" align="center">
        <div v-if="loading" class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          ></v-progress-circular>
          <div class="mt-3">{{ $t('loading_qr_code') }}</div>
        </div>
        <vue-qrcode
          v-else-if="activation"
          :value="'https://konobar.ordera.app/login?activation=' + activation"
          :options="{ width: 200 }"
          style="border: 2px solid gray"
        ></vue-qrcode>
        <div v-else class="text-center">
          <v-icon size="64" color="grey lighten-1">mdi-qrcode</v-icon>
          <div class="mt-3 grey--text">{{ $t('no_qr_code') }}</div>
        </div>
      </v-col>
      <v-col cols="12" class="pa-0" align="center">
        {{ toLatin(employee.name) + " " + toLatin(employee.lastname) }}
      </v-col>
    </v-row>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import userService from "@/services/user";

export default {
  name: "CompanyEmployeeDialogQr",
  mixins: [hasModel, hasSnackbar],
  components: {
    VueQrcode,
  },
  props: {
    employee: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    selectedQrSecret: null,
    activation: null,
    loading: false,
  }),
  methods: {
    printQr(item) {
      this.$emit("print", item);
    },
    getEmployeeQr() {
      if (!this.employee?.id) return;
      
      this.loading = true;
      this.activation = null; // Reset activation
      
      userService
        .getUserActivation(this.employee.id)
        .then((res) => {
          this.activation = res.data;
        })
        .catch((error) => {
          console.error("Error getting QR activation:", error);
          this.showErrorSnackbar(this.$t('error_loading_qr_code'));
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    employee: {
      immediate: true,
      handler() {
        this.getEmployeeQr();
      },
    },
  },
};
</script>
